import { useEffect } from "react";
import { useSelector } from "react-redux";
import { AlgoliaSearchParams } from "../../../../api/postCall/algoliaSearch";
import { MyMedicalPaOrdersTableData } from "../../../../data-model/tablesData";
import { TableNames } from "../../../../enums/tableNames";
import { RootState } from "../../../../redux/store/store";

import { useTablesContext } from "../../../../context/tablesContextProvider";
import { makePostCallForMyPaOrders } from "../apis/makePostCallForMyPaOrders";
import { MyMedicalPaOrdersState } from "./useMyPaOrdersTableData";

export const useFilterAndSearchEffect = (
  filterPayload: AlgoliaSearchParams | null | undefined,
  initialDataFetchingExecuted: boolean,
  setTableData: React.Dispatch<
    React.SetStateAction<MyMedicalPaOrdersTableData[]>
  >,
  setMyMedicalPaOrdersState: React.Dispatch<
    React.SetStateAction<MyMedicalPaOrdersState>
  >,
  setPaginationResetCount: React.Dispatch<React.SetStateAction<number>>,
) => {
  const { data: authStatusOptions } = useSelector(
    (state: RootState) => state.authStatusOptions,
  );
  const { setTableDataForContext } = useTablesContext();

  useEffect(() => {
    if (
      filterPayload &&
      initialDataFetchingExecuted &&
      authStatusOptions &&
      authStatusOptions.length > 0
    ) {
      makePostCallForMyPaOrders(
        filterPayload,
        authStatusOptions,
        setMyMedicalPaOrdersState,
        setTableData,
        setPaginationResetCount,
      );
      setTableDataForContext(TableNames.MY_PA_ORDERS_FROM_ALGOLIA, {
        lastBatchFetched: 0,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterPayload, authStatusOptions]);
};
